import * as React from "react";

import { Spinner } from "../Spinner/Spinner";

export interface ILoadingFeedback {
  isLoading: boolean;
  error: string | null;
}

export const LoadingFeedback = (props: ILoadingFeedback) => {
  return (
    <>
      {props.isLoading && <Spinner loading={props.isLoading} />}
      {props.error && <span className="alert alert-danger error-text">{props.error}</span>}
    </>
  );
};
